<template>
    <div class="bzj_sm">
        <div class="tit">
            <div class="tit-item" :class="{'active': otype == 1}" @click="otype = 1">寄售交易</div>
            <div class="tit-item" :class="{'active': otype == 2}" @click="otype = 2">担保交易</div>
        </div>
        <p v-if="otype == 1">将现有的游戏角色或账号暂时寄存在官方交易平台，客服核实截图上架，所有玩家都可以以进行购买，买家购买后，联系客服进行发货。</p>
        <p v-else>卖家只需在官方交易平台上发布担保出售信息，获得口令，然后给到指定买家进行购买，购买后联系客服进行发货</p>
        <van-button round color="var(--theme)" class="know" @click="close">我已知晓</van-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                otype: this.selection.otype
            }
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .bzj_sm {
        padding: 2.4rem 2.6rem;

        .tit {
            font-size: 1.6rem;
            color: #FE6455;
            font-weight: 700;
            margin-bottom: 1.9rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 2.9rem;
            .tit-item {
                color: #606060;
                padding-bottom: .8rem;
                border-bottom: 2px solid transparent;
                cursor: pointer;
                &.active {
                    color: #F66F30;
                    border-color: #F66F30;
                }
            }
        }

        p {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.5;
        }

        .know {
            width: 24rem;
            height: 3.2rem;
            display: block;
            margin: 1.9rem auto 0;
            font-size: 1.6rem;
        }
    }
</style>